<div class="dialog-container">
    <h4 *ngIf="data.type === 'timesheet'" mat-dialog-title class="dialog-title">Process Timesheet</h4>
    <h4 *ngIf="data.type === 'schedule'" mat-dialog-title class="dialog-title">Create Schedule Process</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <div *ngIf="data.type === 'timesheet'">
            <form *ngIf="!isProcessed" [formGroup]="processForm2" class="col-12">
                <div class="row">
                    <mat-form-field class="col-6" appearance="outline">
                        <mat-label>Select Payroll</mat-label>
                        <input type="text" matInput [formControl]="payrollCtrl" [matAutocomplete]="autoPayroll"
                            required>
                        <mat-autocomplete #autoPayroll="matAutocomplete"
                            (optionSelected)="onPayrollSelected($event.option.value)">
                            <!-- <mat-option [value]="''">-- None --</mat-option> -->
                            <mat-option *ngFor="let payroll of filteredPayrolls | async" [value]="payroll.payrollType">
                                {{ payroll.payrollType }}
                            </mat-option>
                        </mat-autocomplete>
                        <button mat-icon-button matSuffix tabindex="-1">
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field class="col-6" appearance="outline">
                        <mat-label>Select Period</mat-label>
                        <input type="text" matInput [formControl]="periodCtrl" [matAutocomplete]="autoPeriod" required>
                        <mat-autocomplete #autoPeriod="matAutocomplete"
                            (optionSelected)="onPeriodSelected($event.option.value)">
                            <!-- <mat-option [value]="''">-- None --</mat-option> -->
                            <mat-option *ngFor="let period of filteredPeriods | async" [value]="period.payrollName">
                                {{ period.payrollName }}
                            </mat-option>
                        </mat-autocomplete>
                        <button mat-icon-button matSuffix tabindex="-1">
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field appearance="outline" class="col-6">
                        <mat-label>Status</mat-label>
                        <mat-select [(ngModel)]="status" name="status">
                            <mat-option *ngFor="let status of statusList" [value]="status.value">
                                {{ status.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </form>
            <div *ngIf="isProcessed" class="w-100 text-center mt-1">
                <h6>{{message}}</h6>
            </div>
        </div>
        <div *ngIf="data.type === 'schedule'">
            <form *ngIf="!isProcessed" [formGroup]="processForm" class="col-12">
                <div class="row">
                    <mat-form-field class="col-6" appearance="outline">
                        <mat-label>Select Payroll</mat-label>
                        <input type="text" matInput [formControl]="payrollCtrl" [matAutocomplete]="autoPayroll"
                            required>
                        <mat-autocomplete #autoPayroll="matAutocomplete"
                            (optionSelected)="onPayrollSelected($event.option.value)">
                            <!-- <mat-option [value]="''">-- None --</mat-option> -->
                            <mat-option *ngFor="let payroll of filteredPayrolls | async" [value]="payroll.payrollType">
                                {{ payroll.payrollType }}
                            </mat-option>
                        </mat-autocomplete>
                        <button mat-icon-button matSuffix tabindex="-1">
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field class="col-6" appearance="outline">
                        <mat-label>Select Period</mat-label>
                        <input type="text" matInput [formControl]="periodCtrl" [matAutocomplete]="autoPeriod" required>
                        <mat-autocomplete #autoPeriod="matAutocomplete"
                            (optionSelected)="onPeriodSelected($event.option.value)">
                            <!-- <mat-option [value]="''">-- None --</mat-option> -->
                            <mat-option *ngFor="let period of filteredPeriods | async" [value]="period.payrollName">
                                {{ period.payrollName }}
                            </mat-option>
                        </mat-autocomplete>
                        <button mat-icon-button matSuffix tabindex="-1">
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field class="col-6" appearance="outline">
                        <mat-label>Schedule</mat-label>
                        <input type="text" matInput [formControl]="scheduleCtrl" [matAutocomplete]="autoSchedule"
                            required>
                        <mat-autocomplete #autoSchedule="matAutocomplete"
                            (optionSelected)="onScheduleSelected($event.option.value)">
                            <mat-option *ngFor="let schedule of filteredSchedules | async" [value]="schedule.name">
                                {{ schedule.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <button mat-icon-button matSuffix tabindex="-1">
                            <mat-icon>arrow_drop_down</mat-icon>
                        </button>
                    </mat-form-field>
                    <!-- <mat-form-field appearance="outline" class="col-6 custom-datetime-field">
                        <mat-label>Start Date & Time</mat-label>
                        <input matInput type="datetime-local" formControlName="startDate" required />
                        <mat-hint>MM/DD/YYYY, HH:mm</mat-hint>
                    </mat-form-field> -->
                </div>
            </form>
            <div *ngIf="isProcessed" class="w-100 text-center mt-1">
                <h6>{{message}}</h6>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-0 text-right">
        <button mat-button class="cancel-button" (click)="onNoClick()">Close</button>
        <div *ngIf="!isProcessed">
            <button mat-button class="yes-button" cdkFocusInitial (click)="onSubmit()"
                *ngIf="!isLoading; else loadingTemplate">Submit</button>
            <ng-template #loadingTemplate>
                <button mat-button type="button" class="yes-button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </ng-template>
        </div>
    </div>
</div>